import { Link, useNavigate } from "react-router-dom";
import { AppointmentTicketRequestInterface } from "../../../Interfaces/AppointmentCardInterface";
import { ShiftResource } from "../../../resource/shiftResource";
import { Button, Icon } from "../../Elements";
import Avatar from "../ImageAvatars/Avatar";
import { useDispatch, useSelector } from "react-redux";
import { ReducerType } from "../../../storeManager/ReducerType";
import { LoginInterface } from "../../../Interfaces/LoginInterface";
import useFetch from "../../../_services/fetch";
import { PrescriptionViewModel } from "../../../models/ViewModels/PrescriptionViewModel";
import { RaytebRequests } from "../../../_services";
import { addOrUpdatePrescription } from "../../../storeManager/Reducers/prescriptionSlice";
import LoadingFit from "../Loading/LoadingFit";
import { GenderEnum } from "../../../enums/GenderEnum";

const AppointmentTicketRequestCard: React.FC<
  AppointmentTicketRequestInterface & {
    currentTicketId;
    onToggleIsEnd: VoidFunction;
  }
> = (props) => {
  const dispatch = useDispatch();

  const navigation = useNavigate();
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser,
  );
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter,
  );
  const prescriptionRequest = useFetch<PrescriptionViewModel, Object>({
    request: RaytebRequests.Prescription_Get_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) {
      dispatch(addOrUpdatePrescription(data));
      if (center.hasRecord) navigation("/prescription/record");
      else navigation("/prescription/newPrescription");
    },
  });
  const toggleIsEndTicketRequest = useFetch<
    unknown,
    ToggleIsEndTicketRequestInputModel
  >({
    request: RaytebRequests.Appointment_ToggleIsEndTicketRequest_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) {
      props.onToggleIsEnd();
    },
  });
  function isToday(date: Date) {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }
  return (
    <div
      className={`flex rounded-lg flex-col ${props.ticketId === props.currentTicketId ? "ring-1 ring-blue-400" : ""} ${props.isVisit ? "bg-primary/20" : "bg-white"}  p-1 relative shadow-inner  w-full transition-all duration-75`}
    >
      <LoadingFit isLoading={prescriptionRequest.isLoading} />
      <div className="grid grid-cols-12 items-start  px-2 py-1 min-h-[133px]">
        <div className="col-span-2">
          <Avatar url={props.imageUrl} className="!w-12 !h-12" />
        </div>
        <div className="flex flex-col justify-center items-start gap-1 col-span-7 pr-1  py-2">
          <h2 className="text-primaryDark">{`${props.firstName} ${props.lastName}`}</h2>
          <p className="text-xs text-primaryLight font-bold flex gap-3 ">
            <span>{props.code?.toPersian()}</span>
            <span>{props.gender ? GenderEnum[props.gender] : "مامشخص"}</span>
            <span>{props.age}</span>
          </p>
          <div className="flex gap-3 text-xs text-primaryLight">
            <span>{props.ticketTime}</span>
            <span> نوبت : {props.ticketNo}</span>
            <span> شیقت : {ShiftResource[props.shift]}</span>
          </div>
          {props.trackingCode ? (
            <span className="text-xs  text-primaryLight">
              کد پیگیری : {props.trackingCode.toPersian()}
            </span>
          ) : (
            ""
          )}
          <span className="text-xs text-primaryLight">
            {props.hasAnyItems
              ? " تاریخچه معاینه قبلی دارد"
              : " تاریخچه معاینه قبلی ندارد"}
          </span>
        </div>
        <div className="col-span-3 flex flex-col justify-between items-end h-full py-2">
          <div className="grid grid-cols-2 justify-end items-center gap-2">
            {props.appointmentType === "IsVideoChat" ? (
              <Icon
                icon="rayteb-video-camera"
                className="!text-2xl text-danger"
                onClick={() => {
                  props.onStartMetting?.();
                }}
              />
            ) : null}
            <Link
              to={
                props.ticketId === props.currentTicketId
                  ? "/TicketRequest"
                  : `/TicketRequest?ticketId=${props.ticketId}&date=${props.visitDate}`
              }
            >
              <Icon icon="rayteb-chat" className="!text-2xl text-secondary" />
            </Link>

            {props.isEnd ? (
              <Button
                onClick={() =>
                  toggleIsEndTicketRequest.reFetch({
                    ticketId: props.ticketId!,
                  })
                }
                type="button"
                className={`!bg-secondaryLight/40 text-secondaryDark !border-dangerDark  
                    shadow-sm !text-xs font-bold !px-2
                    col-span-2 py-1`}
              >
                بازکردن چت
              </Button>
            ) : (
              <Button
                onClick={() => {
                  toggleIsEndTicketRequest.reFetch({
                    ticketId: props.ticketId!,
                  });
                }}
                type="button"
                className={`!bg-dangerLight/40 text-dangerDark !border-dangerDark  
                    shadow-sm !text-xs font-bold !px-2
                    col-span-2 py-1`}
              >
                بستن چت
              </Button>
            )}
          </div>
          <div className="flex flex-col gap-3">
            {props.hasAnyItems ? (
              <Link
                to={`${window.env["APP_Domain"]}/api/DoctorProfile/Patient/GetAllProfiles?doctorCode=${user.userData?.code}&centerId=${center.id}&patientCode=${props.code}`}
                className="!text-primary !bg-none text-center !border-0 !text-[11px] hover:!border-b 
            hover:shadow-inner
        !font-bold  !w-full "
                target="_blank"
              >
                چاپ کل پرونده
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className="flex py-2 justify-start items-center">
        {isToday(new Date(props.visitDate!)) &&
        (center.hasRecord || center.hasPrescription) ? (
          <Button
            className="bg-none border-0 !bg-inherit gap-2 !w-full !p-0"
            onClick={() => {
              prescriptionRequest.reFetch({
                code: props.code,
                ticketId: props.ticketId,
              });
            }}
          >
            <Icon
              icon="rayteb-prescription"
              className={`text-xl text-disable`}
            />
            <span className="text-xs text-primary ">تجویز کنید</span>
          </Button>
        ) : (
          <></>
        )}
        {props.hasPrescription === true || props.hasRecord === true ? (
          <Button
            className={`bg-none border-0 !bg-inherit gap-2 !w-full !p-0`}
            onClick={() => {
              window.open(
                `${window.env["APP_Domain"]}/api/DoctorProfile/Patient/PrintPatientProfileWithPrescription?centerId=${center.id}&doctorCode=${user.userData?.code}&patientCode=${props.code}&insertDate=${props.visitDate}`,
              );
            }}
          >
            <Icon icon="rayteb-record" className={`text-xl text-disable`} />
            <span className="text-xs text-primary ">چاپ پرونده</span>
          </Button>
        ) : (
          <></>
        )}
        {props.isSend && props.hasPrescription === true ? (
          <Button
            className="bg-none border-0 !bg-inherit gap-2 !w-full !p-0"
            onClick={() => {
              window.open(
                `${window.env["APP_Domain"]}/api/DoctorProfile/Prescription/Print?ticketId=${props.ticketId}`,
              );
            }}
          >
            <Icon icon="rayteb-printer" className={`text-xl text-disable`} />
            <span className="text-xs text-primary ">چاپ نسخه</span>
          </Button>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default AppointmentTicketRequestCard;
